//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/lib/utils'
import { mapState } from 'vuex'

import clients from '@/graphql/queries/clients/clients.gql'

export default {
  name: 'ClientPicker',
  props: {
    value: {
      type: String
    },
    noAccountOption: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      clients: [],
      inputValue: this.value || '',
      selected: null
    }
  },
  apollo: {
    clients
  },
  methods: {
    formatDate,
    clientAccounts(client, limit = null) {
      const accounts = [...client.redditAccounts, ...client.socialAccounts]
      if (limit) {
        return accounts.slice(0, limit)
      }
      return accounts
    }
  },
  computed: {
    ...mapState(['profile']),
    selectedClient() {
      if (!this.inputValue) {
        return null
      }
      return this.clients.find((account) => account.id === this.inputValue)
    }
  },
  watch: {
    inputValue(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
        this.$emit('clientSelected', this.selectedClient)
      }
    },
    value(val, oldVal) {
      this.inputValue = val
    }
  }
}
